export const sortByBalance = a => {
  return a.starting;
};

export const sortByInterest = a => {
  return a.interest;
};

export const sortByName = a => {
  return a.name.toLowerCase();
};

export const sortByOrder = a => {
  return a.order;
};

export const sortByProgress = a => {
  return a.current / a.starting;
};

export const getSort = sortType => {
  const sortMap = {
    alphabetical: sortByName,
    balanceLowest: sortByBalance,
    interestHighest: sortByInterest,
    paydownOrder: sortByOrder,
    progressLeast: sortByProgress,
    progressMost: sortByProgress,
  };

  const sortMethod = sortMap[sortType] || sortMap['alphabetical'];
  const sortDirection = ['interestHighest', 'progressLeast'].includes(sortType) ? 'desc' : 'asc';

  return { sortDirection, sortMethod };
};

export default getSort;



// WEBPACK FOOTER //
// ./src/utils/sorts.js